import styled from "styled-components";
import { Box } from "@mui/material";

export const PrivacyPolicySection = styled(Box)`
	padding: 60px 40px;

	.page-title {
		font-family: var(--poppins), sans-serif;
		font-weight: bold;
		font-size: 34px;
		color: #373737;
		margin-bottom: 8px;
	}

	.effective-date {
		font-family: var(--openSans), sans-serif;
		font-size: 13px;
		color: #888;
		margin-bottom: 40px;
	}

	.policy-intro {
		font-family: var(--openSans), sans-serif;
		font-size: 15px;
		color: #555;
		line-height: 1.8;
		margin-bottom: 40px;
		max-width: 800px;
	}

	.section {
		margin-bottom: 36px;

		.section-title {
			font-family: var(--poppins), sans-serif;
			font-weight: 700;
			font-size: 18px;
			color: #373737;
			margin-bottom: 12px;
		}

		.sub-title {
			font-family: var(--poppins), sans-serif;
			font-weight: 600;
			font-size: 15px;
			color: #444;
			margin-top: 16px;
			margin-bottom: 6px;
		}

		.section-body {
			font-family: var(--openSans), sans-serif;
			font-size: 14px;
			color: #555;
			line-height: 1.85;
		}

		ul {
			margin: 8px 0 0 0;
			padding-left: 22px;

			li {
				font-family: var(--openSans), sans-serif;
				font-size: 14px;
				color: #555;
				line-height: 2;
			}
		}
	}

	.contact-box {
		background: #f5f9ff;
		border-radius: 8px;
		padding: 20px 24px;
		display: inline-block;
		margin-top: 10px;

		a {
			color: #1976d2;
			text-decoration: none;
			font-weight: 600;
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		padding: 16px;
		padding-top: 60px;
		.page-title {
			font-size: 26px;
		}
	}

	&[dir="rtl"] {
		.page-title,
		.effective-date,
		.policy-intro,
		.section-title,
		.sub-title,
		.section-body,
		ul li,
		.contact-box p {
			font-family: var(--quran), sans-serif;
		}

		ul {
			padding-left: 0;
			padding-right: 22px;
		}
	}
`;
